import { create } from 'zustand';

// Estado de sincronización offline — lo lee el indicador en el header
export const useSyncStore = create((set, get) => ({
  isOnline:       true,
  pendingCount:   0,   // jobs en la outbox pendientes de sync
  errorCount:     0,   // jobs con error permanente (necesitan revisión)
  lastSyncAt:     null,

  setOnline:   (v) => set({ isOnline: v }),
  setPending:  (n) => set({ pendingCount: n }),
  setErrors:   (n) => set({ errorCount: n }),
  setSyncedAt: ()  => set({ lastSyncAt: new Date().toISOString() }),
}));
